export default __webpack_public_path__ + "static/review-1d35f6a521489598a7c140719c9d8dd2.jpg";